import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import RAD from "../../assets/Radiator.png";

const RadiatorReplacement = () => {
  return (
    <>
      <SeoHead
        title="Radiator Replacement in Temecula | Advanced Automotive Smog"
        description="Radiator replacement in Temecula for leaking, clogged, or damaged radiators, including a full check of hoses, clamps, and coolant levels."
        path="/services/radiator-replacement"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Radiator Replacement"
          path="/services/radiator-replacement"
          description="Radiator replacement in Temecula for leaking, clogged, or damaged radiators, including a full check of hoses, clamps, and coolant levels."
          serviceType="Radiator replacement"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">
          {/* Image - mobile priority */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={RAD}
                alt="Radiator replacement service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Cooling System
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Radiator Replacement
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Your radiator is the heart of the cooling system, keeping engine
              temperatures under control. When it&apos;s leaking, clogged, or
              damaged, your engine can overheat and suffer serious damage.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is Radiator Replacement?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Radiator replacement involves removing the failing unit and
              installing a new, high-quality radiator that restores proper
              cooling. We also inspect hoses, clamps, and coolant levels to make
              sure the entire system is ready for the road.
              <br />
              <br />
              Our technicians test for leaks, verify proper coolant flow, and
              help protect your engine from overheating and long-term damage.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Comprehensive radiator inspection and pressure testing
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                High-quality replacement radiators for most makes and models
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Professional removal and installation for proper fit and seal
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Helps prevent overheating and engine damage
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Restores efficient cooling for long-term performance
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default RadiatorReplacement;

